import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TopMenu from './TopMenu';
import BackButton from './BackButton';
import SideMenu from './SideMenu';
import KickedNotice from './KickedNotice';
import SngResultNotice from './SngResultNotice';
import TournamentResultNotice from './TournamentResultNotice';
import AwayTableNotice from './AwayTableNotice';
import "./AppLayout.css";
import "./SidePanels.css";

const AppLayout = () => {
    const location = useLocation();
    const hideTopMenuPaths = ["/", "/login"];
    const backButtonPaths = ["/rooms", "/leaderboard", "/settings", "/customize"];
    // Pages that show the home chrome: the hamburger menu (left).
    const homeControlsPaths = ["/home", "/rooms", "/leaderboard"];
    const activeGameScreen = useSelector((state) => state.games.activeGameScreen);

    const [menuOpen, setMenuOpen] = useState(false);

    const showTopMenu = !hideTopMenuPaths.includes(location.pathname) && !activeGameScreen;
    const showBackButton = backButtonPaths.includes(location.pathname) && !activeGameScreen;
    const showHomeControls = homeControlsPaths.includes(location.pathname) && !activeGameScreen;

    return(
        <>
            {showBackButton && <BackButton />}
            {showHomeControls && (
                <>
                    {!menuOpen && (
                        <button
                            className="corner-button menu-button"
                            onClick={() => setMenuOpen(true)}
                            aria-label="Open menu"
                        >
                            &#9776;
                        </button>
                    )}
                    <SideMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
                </>
            )}
            {showTopMenu && <TopMenu />}
            <div className={showTopMenu ? "content" : ""}>
                <Outlet />
            </div>
            <KickedNotice />
            <SngResultNotice />
            <TournamentResultNotice />
            <AwayTableNotice />
        </>
    );
};

export default AppLayout;
